import Component from "../abstracts/Component";

export default class QuickCategoriesComponent extends Component{
  get SELECTORS() {
    return {
      main: '[data-quick-categories]:not([data-quick-categories=""])'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on('click.qc', ({event}) => {
      this.$emit(this.$customEvents.QUICK_CATEGORIES_EVENTS.show, {id: event.currentTarget.dataset.quickCategories})
    }, this.SELECTORS.main);
  }

  render () {
    if (this.$matchMedia('sm') && document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
